import { Card } from "../Card";
import { Text } from "@mdotm/shadcn/legacy/components";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import type { ReactNode } from "react";

export type PageHeaderFooterProps = {
	pageIndex: number;
	totalPages: number;
};

export type PageHeaderFooterComponent = (props: PageHeaderFooterProps) => ReactNode;

const Header = (props: PageHeaderFooterProps & { title: string; subtitle?: string }): React.JSX.Element => {
	const { pageIndex, title, totalPages, subtitle } = props;

	/* First page is the cover, second page is "page one" */
	return pageIndex === 1 ? (
		<Card>
			<div className="flex mt-16 items-start justify-between gap-4">
				<div className="min-w-0">
					<Text as="div" type="Title/M/Bold" className="truncate" color={themeCSSVars.palette_N700}>
						{title}
					</Text>
					{subtitle && (
						<Text as="h4" type="Body/M/Book" color={themeCSSVars.palette_N700}>
							{subtitle}
						</Text>
					)}
				</div>
				<Text as="h4" type="Body/M/Book" color={themeCSSVars.palette_N700} className="whitespace-nowrap">
					{/* totalPages includes the cover */}
					Pag {pageIndex}/{totalPages - 1}
				</Text>
			</div>
		</Card>
	) : (
		<div className="flex items-center justify-between px-12 mt-16">
			<div>
				<Text color={themeCSSVars.palette_N700} type="Body/M/Bold">
					{title}
				</Text>
				<Text color={themeCSSVars.palette_N700} type="Body/M/Book" className="mx-2">
					|
				</Text>
				<Text color={themeCSSVars.palette_N700} type="Body/M/Book">
					{subtitle}
				</Text>
			</div>
			<Text as="div" type="Body/M/Book" color={themeCSSVars.palette_N700} className="whitespace-nowrap">
				{/* totalPages includes the cover */}
				Pag {pageIndex}/{totalPages - 1}
			</Text>
		</div>
	);
};

export default Header;
